/* eslint-disable max-len */
/** import package [start] */
import axios, { AxiosInstance } from 'axios';
import BaseUrls from './baseUrls';

const apiBackendInstance: AxiosInstance = axios.create({
  baseURL: BaseUrls.getApplicationBackendUrl(),
});
export default apiBackendInstance;